export const SET_OPEN_CALENDAR = "DELIVERYTIMES/SET_OPEN_CALENDAR";
export const SET_DELIVERY_TIME = "DELIVERYTIMES/SET_DELIVERY_TIME";
export const SET_CLOSE_MODAL_CALENDAR = "DELIVERYTIMES/SET_CLOSE_MODAL_CALENDAR";
